<div class="component-container">
    <div class="bottom-action-mg groups-shops-create-form-container" fxLayoutGap="1rem">
        <custom-panel
            [header]="'Szczegóły regału'"
            [areButtons]="false"
        >
            <div panel-body *ngIf="!isLoading">
                <div class="features-details-wrapper mt-xxs" fxLayout="column">
                    <div>
                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>ID: <span class="text-primary pl-xxs">{{ id }}</span></p>
                        </div>

                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>NAZWA: <span class="text-primary pl-xxs">{{ name }}</span></p>
                        </div>

                        <div class="group references-group mt-xs" fxFlex="33%">
                            <p>METRY: <span class="text-primary pl-xxs">{{ meters }}</span></p>
                        </div>
                    </div>


                </div>
            </div>
            <div panel-body class="text-center pb-s ml-s mt-xs" *ngIf="isLoading">
                <button-spinner [inProgress]="isLoading" diameter="100">
                </button-spinner>
            </div>
        </custom-panel>
    </div>
</div>

<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row" fxLayoutGap="1%" fxLayoutAlign="flex-end center">
        <button-spinner class="ml-xxs" [inProgress]="isDeleting" diameter="20">
        </button-spinner>
        <button type="button" class="upper action-button butt-back action-button-icon"
                (click)="generalService.goBack()"
        >
            <p class="upper">Wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button (click)="openDialog()"
                [disabled]="isDeleting"
                class="upper action-button butt-red action-button-icon"
        >
            <p class="upper">usuń</p>
            <mat-icon class="action-icon">delete</mat-icon>
        </button>
        <button (click)="navToEdit()"
                class="upper action-button butt-primary action-button-icon">
            <p class="upper">edytuj</p>
            <mat-icon class="action-icon">edit</mat-icon>
        </button>
    </div>
</div>
